export const generateRandomDate = () => {
    const today = new Date();
    const daysAgo = Math.floor(Math.random() * 7) + 1;
    const pastDate = new Date(today);
    pastDate.setDate(today.getDate() - daysAgo);

    const options = { month: 'long', day: 'numeric', year: 'numeric' };
    return pastDate.toLocaleDateString('en-US', options);
};
